import React, { useEffect } from "react";
import "./RedirectExternal.scss";
import { getLanguagePaths } from "../../../helpers/menuConfig";
import i18n from "../../../i18n";
import { getCorrectLink } from "../../../helpers/helpers";
import Loader from "../Loader/Loader";
import { useSelector } from "react-redux";

const RedirectExternal = (props) => {
  const { language } = i18n;
  const languagePaths = getLanguagePaths();
  const match = props.match || props.computedMatch;
  const { link = null } = match.params;
  const app = useSelector((state) => state.app);
  console.log(app);
  useEffect(() => {
    if (link) {
      if (link === "search") {
        const { redirectSearchSuggestion } = app;
        window.location.href = redirectSearchSuggestion
          ? `${redirectSearchSuggestion}`
          : getCorrectLink(languagePaths["home"][language]);
      } else if (typeof window !== "undefined") {
        window.location.href = getCorrectLink(
          languagePaths[link]
            ? languagePaths[link][language]
            : languagePaths["home"][language]
        );
      }
    } else {
      window.location.href = getCorrectLink(languagePaths["home"][language]);
    }
    // eslint-disable-next-line
  }, []);
  return (
    <div data-testid="RedirectExternal" className={"RedirectExternal"}>
      <div style={{ height: 1000 }}>
        <Loader />
      </div>
    </div>
  );
};

RedirectExternal.propTypes = {};

export default RedirectExternal;
